import classNames from 'classnames';
import styles from './BaseElement.module.css';
import { canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { BaseColors } from '../BaseColors/BaseColors';
import Tippy from "@tippyjs/react";
import { ColorResult, SketchPicker } from "react-color";

interface IBaseElement {
    id: string;
    name: string;
    selectedBackgroundName: string;
    price: number;
    img: string;
    selected?: boolean;
    onSelect: () => void;
    selectedColorPicker: string;
    keyProp: number;
    isPrem: boolean;
    premPrice: number;
    backgroundDataName: string;
}

interface IOptionTooltipContentProps {
    content: string;
}

export const BaseElement = (element: IBaseElement) => {
    const {
        keyProp,
        id,
        name,
        selectedBackgroundName,
        price,
        img,
        selectedColorPicker,
        isPrem,
        premPrice,
        selected,
        onSelect,
        backgroundDataName
    } = element;

    const [isOpenPopover, setOpenPopover] = useState(false);
    const isMobile = window.innerWidth < 991;
    const isColorPicker = +id === 1607;
    const popoverRef = useRef<HTMLDivElement>(null);
    const colorPickerRef = useRef<HTMLDivElement>(null);
    const closePopoverRef = useRef<HTMLDivElement>(null);
    const [userColor, setUserColor] = useState<string>(selectedColorPicker);
    const [isColorPickerOpen, setIsColorPickerOpen] = useState<boolean>(false);
    const handlePopoverOpen = () => {
        setOpenPopover(true);
    };

    const handlePopoverClose = () => {
        if(isOpenPopover) {
            setOpenPopover(false);
        }
    };

    const onSelectBackground = () => {
        onSelect();
    };

    const { backgroundData, setBackgroundData } = useContext(canvasBackgroundContext);

    const currentBackgroundData = backgroundData.items
        .filter(item => item.groupName === name);

    const handleChoose = (newUserColor?:string) => {
        let userColorDefault = '';
        if(isColorPicker && !isColorPickerOpen) {
            if(!userColor) setUserColor('#7F3F3F');
            setIsColorPickerOpen(!isColorPickerOpen);
            userColorDefault = '#7F3F3F';
        }

        const backgroundColor = newUserColor
            ? newUserColor
            : userColor && userColor.length
                ? userColor
                // : '#7F3F3F';
                : userColorDefault;

        const colorsName = currentBackgroundData[0].colors[0].name ? currentBackgroundData[0].colors[0].name : backgroundData.items[0].colors[0].name;

        setBackgroundData({
            img: img,
            backgroundColor: backgroundColor,
            // name: backgroundColor ?? currentBackgroundData[0].colors[0].name,
            name: backgroundColor ? backgroundColor : colorsName,
            price: isPrem ? price + premPrice : price,
            groupName: userColor ? 'Цвет заказчика' : name,
            isSeamless: backgroundData.isSeamless,
            isSeamlessMode: currentBackgroundData[0].isSeamlessMode,
            items: backgroundData.items,
        });

        onSelect();
    };

    useEffect(() => {
        function handleClick(event: MouseEvent) {
            event.stopPropagation();
            if(isOpenPopover && event.target instanceof Node && !popoverRef.current?.contains(event.target)) {
                handlePopoverClose();
            }

            if(isColorPicker
                && event.target instanceof Node && !colorPickerRef.current?.contains(event.target)
                && event.target instanceof Node && !popoverRef.current?.contains(event.target)
            ) {
                setIsColorPickerOpen(false);
            }

            if(isColorPicker && event.target instanceof Node && closePopoverRef.current?.contains(event.target)) {
                setIsColorPickerOpen(false);
            }
        }

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        }
    }, [isOpenPopover]);

    const handleColorPickerChangeComplete = (color: ColorResult) => {
        setUserColor(color.hex);
        handleChoose(color.hex);
    }

    return (
        <>
            <Box ref={popoverRef} className={styles.elementBox}>
                <div className={classNames(styles.container, styles.textureContainer)}>
                    <div className={classNames(styles.imageWrap, selected && styles.imageWrapSelected)}>
                        <div className={classNames(styles.imageContainer, styles.textureImageContainer)}>
                            {currentBackgroundData[0] && currentBackgroundData[0].colors.length > 1 && (
                                <div className={classNames(styles.toggleWrapper)}>
                                    {isMobile && (
                                        <div className={classNames(styles.popupToggle)}
                                             onClick={handlePopoverOpen}
                                        >
                                            <svg width="10" height="10" viewBox="0 0 800 800" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_5_2)">
                                                    <path
                                                        d="M800 400C800 620.923 620.985 800 400 800C179.077 800 0 620.923 0 400C0 179.077 179.077 0 400 0C620.985 0 800 179.077 800 400Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath>
                                                        <rect width="800" height="800" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    )}
                                    {!isMobile && (
                                        <Tippy
                                            className={styles.info}
                                            content={<OptionTooltipContent content={'Выберите цвет'}/>}
                                            interactive={true}
                                            interactiveBorder={20}
                                            delay={100}
                                            duration={100}
                                            animation={'scale'}
                                            allowHTML={true}
                                        >
                                            <div className={classNames(styles.popupToggle)}
                                                 onClick={handlePopoverOpen}
                                            >
                                                <svg width="10" height="10" viewBox="0 0 800 800" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_5_2)">
                                                        <path
                                                            d="M800 400C800 620.923 620.985 800 400 800C179.077 800 0 620.923 0 400C0 179.077 179.077 0 400 0C620.985 0 800 179.077 800 400Z"
                                                            fill="black"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath>
                                                            <rect width="800" height="800" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                            </div>
                                        </Tippy>
                                    )}
                                </div>
                            )}
                            {!isColorPicker && (
                                <img src={selectedColorPicker === name || backgroundDataName == name ? backgroundData.img : img}
                                     alt={name}
                                     className={classNames('texture_image')}
                                     onClick={() => {
                                         // handleChoose(currentBackgroundData[0].colors[0].name);
                                         handleChoose();
                                     }}
                                />
                            )}

                            {isColorPicker && (
                                <div style={{
                                    // background: `url(${selectedColorPicker === name ? backgroundData.img : img})`,
                                    background: userColor ? userColor : '',
                                    width: '100%',
                                    height: '100%'
                                }}
                                     className={classNames(styles.textureBackgroundImage)}
                                     onClick={() => handleChoose()}
                                />
                            )}
                        </div>
                    </div>
                    <div className={classNames(styles.name)}>{name}</div>
                    {price > 0 && (
                        <div>
                            <div className={classNames(styles.text, 'price_font')}>от {price} р./м2</div>
                        </div>
                    )}
                    {price === 0 && (
                        <div>
                            <div className={classNames(styles.text, 'price_font')}>входит в стоимость</div>
                        </div>
                    )}
                </div>
                {isColorPicker && isColorPickerOpen && (
                    <div className={classNames(styles.colorPickerContainer)}>
                        <div ref={closePopoverRef} className={classNames(styles.colorPickerCloseButton)}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 5L5 19M5 5L9.5 9.5M12 12L19 19" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                        </div>
                        <SketchPicker
                            className={styles.colorPicker}
                            color={userColor}
                            disableAlpha={true}
                            onChangeComplete={ (color) => handleColorPickerChangeComplete(color) }
                            onChange={ (color) => handleColorPickerChangeComplete(color) }
                        />
                    </div>
                )}
            </Box>

            {isOpenPopover && (
                <div
                    className={classNames(styles.popover)}
                    onClick={event => event.stopPropagation()}
                >
                    <div className={classNames(styles.close)} onClick={handlePopoverClose}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 5L5 19M5 5L9.5 9.5M12 12L19 19" stroke="#000000" strokeWidth="1.5"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    {currentBackgroundData
                        .map((item, key) => {
                            return (
                                <div key={key}
                                     className={classNames(styles.colorsListWrap, name === item.groupName && styles.colorsListWrapVisible)}>
                                    <BaseColors
                                        keyProp={keyProp}
                                        key={key}
                                        onSelect={onSelectBackground}
                                        {...item}
                                    />
                                </div>
                            );
                        })}
                </div>
            )}


            {selected && (
                <div className={'hidden'}>
                    <div id={'js-background-name'}>{selectedBackgroundName}</div>
                    <div id={'js-background-group-name'}>{name}</div>
                </div>
            )}

        </>
    );
};

const OptionTooltipContent = ({ content }: IOptionTooltipContentProps) => {
    return <div className={styles.tooltipContent} dangerouslySetInnerHTML={{ __html: content }}/>;
};